/* tslint:disable */
/* eslint-disable */
/**
 * Ward Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
import type { RequestArgs } from "./base";
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from "./base";

export type ModelObject = string;

/**
 *
 * @export
 * @interface AcceptableValuesEntity
 */
export interface AcceptableValuesEntity {
  /**
   *
   * @type {Array<string>}
   * @memberof AcceptableValuesEntity
   */
  values: Array<string>;
}
/**
 *
 * @export
 * @interface AttendanceEntity
 */
export interface AttendanceEntity {
  /**
   *
   * @type {string}
   * @memberof AttendanceEntity
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AttendanceEntity
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof AttendanceEntity
   */
  userId: string;
  /**
   *
   * @type {string}
   * @memberof AttendanceEntity
   */
  userName: string;
  /**
   *
   * @type {string}
   * @memberof AttendanceEntity
   */
  formId: string;
  /**
   *
   * @type {string}
   * @memberof AttendanceEntity
   */
  image?: string;
  /**
   *
   * @type {Array<number>}
   * @memberof AttendanceEntity
   */
  location?: Array<number>;
  /**
   *
   * @type {string}
   * @memberof AttendanceEntity
   */
  identifier?: string;
  /**
   *
   * @type {string}
   * @memberof AttendanceEntity
   */
  description?: string;
}
/**
 *
 * @export
 * @interface AttendancesGet200Response
 */
export interface AttendancesGet200Response {
  /**
   *
   * @type {number}
   * @memberof AttendancesGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<AttendanceEntity>}
   * @memberof AttendancesGet200Response
   */
  attendances?: Array<AttendanceEntity>;
}
/**
 *
 * @export
 * @interface ChangePasswordDto
 */
export interface ChangePasswordDto {
  /**
   *
   * @type {string}
   * @memberof ChangePasswordDto
   */
  curPassword: string;
  /**
   *
   * @type {string}
   * @memberof ChangePasswordDto
   */
  newPassword: string;
}
/**
 *
 * @export
 * @interface CreateAttendanceDto
 */
export interface CreateAttendanceDto {
  /**
   *
   * @type {string}
   * @memberof CreateAttendanceDto
   */
  formId: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttendanceDto
   */
  image?: string;
  /**
   *
   * @type {Array<number>}
   * @memberof CreateAttendanceDto
   */
  location?: Array<number>;
  /**
   *
   * @type {string}
   * @memberof CreateAttendanceDto
   */
  identifier?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttendanceDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface CreateFormDto
 */
export interface CreateFormDto {
  /**
   *
   * @type {string}
   * @memberof CreateFormDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateFormDto
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof CreateFormDto
   */
  description?: string;
  /**
   *
   * @type {Array<SectionDto>}
   * @memberof CreateFormDto
   */
  sections: Array<SectionDto>;
}
/**
 *
 * @export
 * @interface EnableDisableCollectorDto
 */
export interface EnableDisableCollectorDto {
  /**
   *
   * @type {string}
   * @memberof EnableDisableCollectorDto
   */
  collectorId: string;
}
/**
 *
 * @export
 * @interface FieldDto
 */
export interface FieldDto {
  /**
   *
   * @type {string}
   * @memberof FieldDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof FieldDto
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof FieldDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof FieldDto
   */
  placeholder?: string;
  /**
   *
   * @type {number}
   * @memberof FieldDto
   */
  index: number;
  /**
   *
   * @type {boolean}
   * @memberof FieldDto
   */
  required: boolean;
  /**
   *
   * @type {string}
   * @memberof FieldDto
   */
  type: FieldDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof FieldDto
   */
  globalRef?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof FieldDto
   */
  acceptableValues?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof FieldDto
   */
  acceptableValuesKey?: string;
  /**
   *
   * @type {Array<FieldDto>}
   * @memberof FieldDto
   */
  fields?: Array<FieldDto>;
  /**
   *
   * @type {string}
   * @memberof FieldDto
   */
  fileType?: FieldDtoFileTypeEnum;
}

export const FieldDtoTypeEnum = {
  String: "string",
  StringArray: "string-array",
  Number: "number",
  NumberArray: "number-array",
  Boolean: "boolean",
  SingleChoice: "single-choice",
  MultiChoice: "multi-choice",
  Fields: "fields",
  Files: "files",
} as const;

export type FieldDtoTypeEnum =
  (typeof FieldDtoTypeEnum)[keyof typeof FieldDtoTypeEnum];
export const FieldDtoFileTypeEnum = {
  Image: "image",
  Video: "video",
  Pdf: "pdf",
  File: "file",
} as const;

export type FieldDtoFileTypeEnum =
  (typeof FieldDtoFileTypeEnum)[keyof typeof FieldDtoFileTypeEnum];

/**
 *
 * @export
 * @interface FieldEntity
 */
export interface FieldEntity {
  /**
   *
   * @type {string}
   * @memberof FieldEntity
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof FieldEntity
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof FieldEntity
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof FieldEntity
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof FieldEntity
   */
  placeholder?: string;
  /**
   *
   * @type {number}
   * @memberof FieldEntity
   */
  index: number;
  /**
   *
   * @type {boolean}
   * @memberof FieldEntity
   */
  required: boolean;
  /**
   *
   * @type {string}
   * @memberof FieldEntity
   */
  type: FieldEntityTypeEnum;
  /**
   *
   * @type {string}
   * @memberof FieldEntity
   */
  globalRef?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof FieldEntity
   */
  acceptableValues?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof FieldEntity
   */
  acceptableValuesKey?: string;
  /**
   *
   * @type {Array<FieldEntity>}
   * @memberof FieldEntity
   */
  fields?: Array<FieldEntity>;
  /**
   *
   * @type {string}
   * @memberof FieldEntity
   */
  fileType?: FieldEntityFileTypeEnum;
}

export const FieldEntityTypeEnum = {
  String: "string",
  StringArray: "string-array",
  Number: "number",
  NumberArray: "number-array",
  Boolean: "boolean",
  SingleChoice: "single-choice",
  MultiChoice: "multi-choice",
  Fields: "fields",
  Files: "files",
} as const;

export type FieldEntityTypeEnum =
  (typeof FieldEntityTypeEnum)[keyof typeof FieldEntityTypeEnum];
export const FieldEntityFileTypeEnum = {
  Image: "image",
  Video: "video",
  Pdf: "pdf",
  File: "file",
} as const;

export type FieldEntityFileTypeEnum =
  (typeof FieldEntityFileTypeEnum)[keyof typeof FieldEntityFileTypeEnum];

/**
 *
 * @export
 * @interface FileEntity
 */
export interface FileEntity {
  /**
   *
   * @type {boolean}
   * @memberof FileEntity
   */
  isSuccess: boolean;
  /**
   *
   * @type {number}
   * @memberof FileEntity
   */
  index: number;
  /**
   *
   * @type {string}
   * @memberof FileEntity
   */
  fileName?: string;
  /**
   *
   * @type {string}
   * @memberof FileEntity
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof FileEntity
   */
  error?: string;
}
/**
 *
 * @export
 * @interface FormDto
 */
export interface FormDto {
  /**
   *
   * @type {string}
   * @memberof FormDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof FormDto
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof FormDto
   */
  description?: string;
  /**
   *
   * @type {Array<SectionDto>}
   * @memberof FormDto
   */
  sections: Array<SectionDto>;
}
/**
 *
 * @export
 * @interface FormEntity
 */
export interface FormEntity {
  /**
   *
   * @type {string}
   * @memberof FormEntity
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof FormEntity
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof FormEntity
   */
  version: string;
  /**
   *
   * @type {string}
   * @memberof FormEntity
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof FormEntity
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof FormEntity
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof FormEntity
   */
  status: FormEntityStatusEnum;
  /**
   *
   * @type {Array<SectionEntity>}
   * @memberof FormEntity
   */
  sections: Array<SectionEntity>;
}

export const FormEntityStatusEnum = {
  Draft: "DRAFT",
  Published: "PUBLISHED",
  Archived: "ARCHIVED",
} as const;

export type FormEntityStatusEnum =
  (typeof FormEntityStatusEnum)[keyof typeof FormEntityStatusEnum];

/**
 *
 * @export
 * @interface FormsFormIdResponsesGet200Response
 */
export interface FormsFormIdResponsesGet200Response {
  /**
   *
   * @type {number}
   * @memberof FormsFormIdResponsesGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<ResponseEntityWithoutBody>}
   * @memberof FormsFormIdResponsesGet200Response
   */
  responses?: Array<ResponseEntityWithoutBody>;
}
/**
 *
 * @export
 * @interface JsurlConverterPostRequest
 */
export interface JsurlConverterPostRequest {
  /**
   *
   * @type {string}
   * @memberof JsurlConverterPostRequest
   */
  str?: string | null;
  /**
   *
   * @type {object}
   * @memberof JsurlConverterPostRequest
   */
  obj?: object | null;
}
/**
 *
 * @export
 * @interface LoginDto
 */
export interface LoginDto {
  /**
   *
   * @type {string}
   * @memberof LoginDto
   */
  identifier: string;
  /**
   *
   * @type {string}
   * @memberof LoginDto
   */
  password: string;
}
/**
 *
 * @export
 * @interface LoginEntity
 */
export interface LoginEntity {
  /**
   *
   * @type {UserEntity}
   * @memberof LoginEntity
   */
  me: UserEntity;
  /**
   *
   * @type {string}
   * @memberof LoginEntity
   */
  jwt: string;
}
/**
 *
 * @export
 * @interface MessageEntity
 */
export interface MessageEntity {
  /**
   *
   * @type {string}
   * @memberof MessageEntity
   */
  message: string;
}
/**
 *
 * @export
 * @interface RegisterDto
 */
export interface RegisterDto {
  /**
   *
   * @type {string}
   * @memberof RegisterDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof RegisterDto
   */
  phoneNumber: string;
  /**
   *
   * @type {string}
   * @memberof RegisterDto
   */
  password: string;
  /**
   *
   * @type {string}
   * @memberof RegisterDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof RegisterDto
   */
  image?: string;
}
/**
 *
 * @export
 * @interface ResetCollectorPassword
 */
export interface ResetCollectorPassword {
  /**
   *
   * @type {string}
   * @memberof ResetCollectorPassword
   */
  collectorId: string;
  /**
   *
   * @type {string}
   * @memberof ResetCollectorPassword
   */
  newPassword: string;
}
/**
 *
 * @export
 * @interface ResponseDto
 */
export interface ResponseDto {
  /**
   *
   * @type {object}
   * @memberof ResponseDto
   */
  response: object;
}
/**
 *
 * @export
 * @interface ResponseEntity
 */
export interface ResponseEntity {
  /**
   *
   * @type {object}
   * @memberof ResponseEntity
   */
  response: object;
  /**
   *
   * @type {string}
   * @memberof ResponseEntity
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEntity
   */
  createdAt: string;
  /**
   *
   * @type {number}
   * @memberof ResponseEntity
   */
  responseNumber: number;
  /**
   *
   * @type {string}
   * @memberof ResponseEntity
   */
  submittedBy: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEntity
   */
  userName: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEntity
   */
  formId: string;
}
/**
 *
 * @export
 * @interface ResponseEntityWithoutBody
 */
export interface ResponseEntityWithoutBody {
  /**
   *
   * @type {string}
   * @memberof ResponseEntityWithoutBody
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEntityWithoutBody
   */
  createdAt: string;
  /**
   *
   * @type {number}
   * @memberof ResponseEntityWithoutBody
   */
  responseNumber: number;
  /**
   *
   * @type {string}
   * @memberof ResponseEntityWithoutBody
   */
  submittedBy: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEntityWithoutBody
   */
  userName: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEntityWithoutBody
   */
  formId: string;
}
/**
 *
 * @export
 * @interface SectionCountDto
 */
export interface SectionCountDto {
  /**
   *
   * @type {string}
   * @memberof SectionCountDto
   */
  $ref: string;
  /**
   *
   * @type {string}
   * @memberof SectionCountDto
   */
  type: SectionCountDtoTypeEnum;
}

export const SectionCountDtoTypeEnum = {
  Number: "number",
} as const;

export type SectionCountDtoTypeEnum =
  (typeof SectionCountDtoTypeEnum)[keyof typeof SectionCountDtoTypeEnum];

/**
 *
 * @export
 * @interface SectionCountEntity
 */
export interface SectionCountEntity {
  /**
   *
   * @type {string}
   * @memberof SectionCountEntity
   */
  $ref: string;
  /**
   *
   * @type {string}
   * @memberof SectionCountEntity
   */
  type: SectionCountEntityTypeEnum;
}

export const SectionCountEntityTypeEnum = {
  Number: "number",
} as const;

export type SectionCountEntityTypeEnum =
  (typeof SectionCountEntityTypeEnum)[keyof typeof SectionCountEntityTypeEnum];

/**
 *
 * @export
 * @interface SectionDto
 */
export interface SectionDto {
  /**
   *
   * @type {string}
   * @memberof SectionDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof SectionDto
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof SectionDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof SectionDto
   */
  index: number;
  /**
   *
   * @type {boolean}
   * @memberof SectionDto
   */
  required: boolean;
  /**
   *
   * @type {string}
   * @memberof SectionDto
   */
  type: SectionDtoTypeEnum;
  /**
   *
   * @type {SectionCountDto}
   * @memberof SectionDto
   */
  count?: SectionCountDto;
  /**
   *
   * @type {Array<FieldDto>}
   * @memberof SectionDto
   */
  fields: Array<FieldDto>;
}

export const SectionDtoTypeEnum = {
  Single: "single",
  Multiple: "multiple",
} as const;

export type SectionDtoTypeEnum =
  (typeof SectionDtoTypeEnum)[keyof typeof SectionDtoTypeEnum];

/**
 *
 * @export
 * @interface SectionEntity
 */
export interface SectionEntity {
  /**
   *
   * @type {string}
   * @memberof SectionEntity
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof SectionEntity
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof SectionEntity
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof SectionEntity
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof SectionEntity
   */
  index: number;
  /**
   *
   * @type {boolean}
   * @memberof SectionEntity
   */
  required: boolean;
  /**
   *
   * @type {string}
   * @memberof SectionEntity
   */
  type: SectionEntityTypeEnum;
  /**
   *
   * @type {SectionCountEntity}
   * @memberof SectionEntity
   */
  count?: SectionCountEntity;
  /**
   *
   * @type {Array<FieldEntity>}
   * @memberof SectionEntity
   */
  fields: Array<FieldEntity>;
}

export const SectionEntityTypeEnum = {
  Single: "single",
  Multiple: "multiple",
} as const;

export type SectionEntityTypeEnum =
  (typeof SectionEntityTypeEnum)[keyof typeof SectionEntityTypeEnum];

/**
 *
 * @export
 * @interface UpdateFormStatusDto
 */
export interface UpdateFormStatusDto {
  /**
   *
   * @type {string}
   * @memberof UpdateFormStatusDto
   */
  status: UpdateFormStatusDtoStatusEnum;
}

export const UpdateFormStatusDtoStatusEnum = {
  Draft: "DRAFT",
  Published: "PUBLISHED",
  Archived: "ARCHIVED",
} as const;

export type UpdateFormStatusDtoStatusEnum =
  (typeof UpdateFormStatusDtoStatusEnum)[keyof typeof UpdateFormStatusDtoStatusEnum];

/**
 *
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
  /**
   *
   * @type {string}
   * @memberof UpdateUserDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserDto
   */
  phoneNumber: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserDto
   */
  image?: string;
}
/**
 *
 * @export
 * @interface UserEntity
 */
export interface UserEntity {
  /**
   *
   * @type {string}
   * @memberof UserEntity
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof UserEntity
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof UserEntity
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UserEntity
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof UserEntity
   */
  phoneNumber: string;
  /**
   *
   * @type {string}
   * @memberof UserEntity
   */
  role: UserEntityRoleEnum;
  /**
   *
   * @type {string}
   * @memberof UserEntity
   */
  image?: string;
  /**
   *
   * @type {boolean}
   * @memberof UserEntity
   */
  enabled: boolean;
}

export const UserEntityRoleEnum = {
  Admin: "ADMIN",
  Collector: "COLLECTOR",
} as const;

export type UserEntityRoleEnum =
  (typeof UserEntityRoleEnum)[keyof typeof UserEntityRoleEnum];

/**
 * AcceptableValuesApi - axios parameter creator
 * @export
 */
export const AcceptableValuesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptableValuesGet: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/acceptable-values`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptableValuesKeyGet: async (
      key: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'key' is not null or undefined
      assertParamExists("acceptableValuesKeyGet", "key", key);
      const localVarPath = `/acceptable-values/{key}`.replace(
        `{${"key"}}`,
        encodeURIComponent(String(key))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AcceptableValuesApi - functional programming interface
 * @export
 */
export const AcceptableValuesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    AcceptableValuesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async acceptableValuesGet(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<{ [key: string]: string }>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.acceptableValuesGet(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async acceptableValuesKeyGet(
      key: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AcceptableValuesEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.acceptableValuesKeyGet(key, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * AcceptableValuesApi - factory interface
 * @export
 */
export const AcceptableValuesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AcceptableValuesApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptableValuesGet(
      options?: any
    ): AxiosPromise<{ [key: string]: string }> {
      return localVarFp
        .acceptableValuesGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptableValuesKeyGet(
      key: string,
      options?: any
    ): AxiosPromise<AcceptableValuesEntity> {
      return localVarFp
        .acceptableValuesKeyGet(key, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AcceptableValuesApi - object-oriented interface
 * @export
 * @class AcceptableValuesApi
 * @extends {BaseAPI}
 */
export class AcceptableValuesApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AcceptableValuesApi
   */
  public acceptableValuesGet(options?: AxiosRequestConfig) {
    return AcceptableValuesApiFp(this.configuration)
      .acceptableValuesGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} key
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AcceptableValuesApi
   */
  public acceptableValuesKeyGet(key: string, options?: AxiosRequestConfig) {
    return AcceptableValuesApiFp(this.configuration)
      .acceptableValuesKeyGet(key, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * AttendanceApi - axios parameter creator
 * @export
 */
export const AttendanceApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} attendanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    attendancesAttendanceIdDelete: async (
      attendanceId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'attendanceId' is not null or undefined
      assertParamExists(
        "attendancesAttendanceIdDelete",
        "attendanceId",
        attendanceId
      );
      const localVarPath = `/attendances/{attendanceId}`.replace(
        `{${"attendanceId"}}`,
        encodeURIComponent(String(attendanceId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} formId
     * @param {string} [userId]
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    attendancesGet: async (
      formId: string,
      userId?: string,
      skip?: number,
      limit?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'formId' is not null or undefined
      assertParamExists("attendancesGet", "formId", formId);
      const localVarPath = `/attendances`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (formId !== undefined) {
        localVarQueryParameter["formId"] = formId;
      }

      if (userId !== undefined) {
        localVarQueryParameter["userId"] = userId;
      }

      if (skip !== undefined) {
        localVarQueryParameter["skip"] = skip;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateAttendanceDto} createAttendanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    attendancesPost: async (
      createAttendanceDto: CreateAttendanceDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createAttendanceDto' is not null or undefined
      assertParamExists(
        "attendancesPost",
        "createAttendanceDto",
        createAttendanceDto
      );
      const localVarPath = `/attendances`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createAttendanceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AttendanceApi - functional programming interface
 * @export
 */
export const AttendanceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    AttendanceApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} attendanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async attendancesAttendanceIdDelete(
      attendanceId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AttendanceEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.attendancesAttendanceIdDelete(
          attendanceId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} formId
     * @param {string} [userId]
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async attendancesGet(
      formId: string,
      userId?: string,
      skip?: number,
      limit?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AttendancesGet200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.attendancesGet(
        formId,
        userId,
        skip,
        limit,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {CreateAttendanceDto} createAttendanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async attendancesPost(
      createAttendanceDto: CreateAttendanceDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AttendanceEntity>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.attendancesPost(
        createAttendanceDto,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * AttendanceApi - factory interface
 * @export
 */
export const AttendanceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AttendanceApiFp(configuration);
  return {
    /**
     *
     * @param {string} attendanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    attendancesAttendanceIdDelete(
      attendanceId: string,
      options?: any
    ): AxiosPromise<AttendanceEntity> {
      return localVarFp
        .attendancesAttendanceIdDelete(attendanceId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} formId
     * @param {string} [userId]
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    attendancesGet(
      formId: string,
      userId?: string,
      skip?: number,
      limit?: number,
      options?: any
    ): AxiosPromise<AttendancesGet200Response> {
      return localVarFp
        .attendancesGet(formId, userId, skip, limit, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateAttendanceDto} createAttendanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    attendancesPost(
      createAttendanceDto: CreateAttendanceDto,
      options?: any
    ): AxiosPromise<AttendanceEntity> {
      return localVarFp
        .attendancesPost(createAttendanceDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AttendanceApi - object-oriented interface
 * @export
 * @class AttendanceApi
 * @extends {BaseAPI}
 */
export class AttendanceApi extends BaseAPI {
  /**
   *
   * @param {string} attendanceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AttendanceApi
   */
  public attendancesAttendanceIdDelete(
    attendanceId: string,
    options?: AxiosRequestConfig
  ) {
    return AttendanceApiFp(this.configuration)
      .attendancesAttendanceIdDelete(attendanceId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} formId
   * @param {string} [userId]
   * @param {number} [skip]
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AttendanceApi
   */
  public attendancesGet(
    formId: string,
    userId?: string,
    skip?: number,
    limit?: number,
    options?: AxiosRequestConfig
  ) {
    return AttendanceApiFp(this.configuration)
      .attendancesGet(formId, userId, skip, limit, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateAttendanceDto} createAttendanceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AttendanceApi
   */
  public attendancesPost(
    createAttendanceDto: CreateAttendanceDto,
    options?: AxiosRequestConfig
  ) {
    return AttendanceApiFp(this.configuration)
      .attendancesPost(createAttendanceDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {EnableDisableCollectorDto} enableDisableCollectorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authCollectorDisablePost: async (
      enableDisableCollectorDto: EnableDisableCollectorDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'enableDisableCollectorDto' is not null or undefined
      assertParamExists(
        "authCollectorDisablePost",
        "enableDisableCollectorDto",
        enableDisableCollectorDto
      );
      const localVarPath = `/auth/collector/disable`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        enableDisableCollectorDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EnableDisableCollectorDto} enableDisableCollectorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authCollectorEnablePost: async (
      enableDisableCollectorDto: EnableDisableCollectorDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'enableDisableCollectorDto' is not null or undefined
      assertParamExists(
        "authCollectorEnablePost",
        "enableDisableCollectorDto",
        enableDisableCollectorDto
      );
      const localVarPath = `/auth/collector/enable`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        enableDisableCollectorDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ResetCollectorPassword} resetCollectorPassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authCollectorResetPwdPost: async (
      resetCollectorPassword: ResetCollectorPassword,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'resetCollectorPassword' is not null or undefined
      assertParamExists(
        "authCollectorResetPwdPost",
        "resetCollectorPassword",
        resetCollectorPassword
      );
      const localVarPath = `/auth/collector/reset-pwd`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        resetCollectorPassword,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {LoginDto} loginDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authLoginPost: async (
      loginDto: LoginDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'loginDto' is not null or undefined
      assertParamExists("authLoginPost", "loginDto", loginDto);
      const localVarPath = `/auth/login`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        loginDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authLogoutPost: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/logout`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ChangePasswordDto} changePasswordDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authPasswordChangePost: async (
      changePasswordDto: ChangePasswordDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'changePasswordDto' is not null or undefined
      assertParamExists(
        "authPasswordChangePost",
        "changePasswordDto",
        changePasswordDto
      );
      const localVarPath = `/auth/password/change`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        changePasswordDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {RegisterDto} registerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authRegisterAdminPost: async (
      registerDto: RegisterDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'registerDto' is not null or undefined
      assertParamExists("authRegisterAdminPost", "registerDto", registerDto);
      const localVarPath = `/auth/register/admin`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        registerDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {RegisterDto} registerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authRegisterCollectorPost: async (
      registerDto: RegisterDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'registerDto' is not null or undefined
      assertParamExists(
        "authRegisterCollectorPost",
        "registerDto",
        registerDto
      );
      const localVarPath = `/auth/register/collector`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        registerDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    AuthenticationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {EnableDisableCollectorDto} enableDisableCollectorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authCollectorDisablePost(
      enableDisableCollectorDto: EnableDisableCollectorDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authCollectorDisablePost(
          enableDisableCollectorDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {EnableDisableCollectorDto} enableDisableCollectorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authCollectorEnablePost(
      enableDisableCollectorDto: EnableDisableCollectorDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authCollectorEnablePost(
          enableDisableCollectorDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {ResetCollectorPassword} resetCollectorPassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authCollectorResetPwdPost(
      resetCollectorPassword: ResetCollectorPassword,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authCollectorResetPwdPost(
          resetCollectorPassword,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {LoginDto} loginDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authLoginPost(
      loginDto: LoginDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginEntity>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authLoginPost(
        loginDto,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authLogoutPost(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageEntity>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authLogoutPost(
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {ChangePasswordDto} changePasswordDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authPasswordChangePost(
      changePasswordDto: ChangePasswordDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authPasswordChangePost(
          changePasswordDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {RegisterDto} registerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authRegisterAdminPost(
      registerDto: RegisterDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authRegisterAdminPost(
          registerDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {RegisterDto} registerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authRegisterCollectorPost(
      registerDto: RegisterDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authRegisterCollectorPost(
          registerDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuthenticationApiFp(configuration);
  return {
    /**
     *
     * @param {EnableDisableCollectorDto} enableDisableCollectorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authCollectorDisablePost(
      enableDisableCollectorDto: EnableDisableCollectorDto,
      options?: any
    ): AxiosPromise<MessageEntity> {
      return localVarFp
        .authCollectorDisablePost(enableDisableCollectorDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EnableDisableCollectorDto} enableDisableCollectorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authCollectorEnablePost(
      enableDisableCollectorDto: EnableDisableCollectorDto,
      options?: any
    ): AxiosPromise<MessageEntity> {
      return localVarFp
        .authCollectorEnablePost(enableDisableCollectorDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ResetCollectorPassword} resetCollectorPassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authCollectorResetPwdPost(
      resetCollectorPassword: ResetCollectorPassword,
      options?: any
    ): AxiosPromise<MessageEntity> {
      return localVarFp
        .authCollectorResetPwdPost(resetCollectorPassword, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {LoginDto} loginDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authLoginPost(
      loginDto: LoginDto,
      options?: any
    ): AxiosPromise<LoginEntity> {
      return localVarFp
        .authLoginPost(loginDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authLogoutPost(options?: any): AxiosPromise<MessageEntity> {
      return localVarFp
        .authLogoutPost(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ChangePasswordDto} changePasswordDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authPasswordChangePost(
      changePasswordDto: ChangePasswordDto,
      options?: any
    ): AxiosPromise<MessageEntity> {
      return localVarFp
        .authPasswordChangePost(changePasswordDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {RegisterDto} registerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authRegisterAdminPost(
      registerDto: RegisterDto,
      options?: any
    ): AxiosPromise<UserEntity> {
      return localVarFp
        .authRegisterAdminPost(registerDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {RegisterDto} registerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authRegisterCollectorPost(
      registerDto: RegisterDto,
      options?: any
    ): AxiosPromise<UserEntity> {
      return localVarFp
        .authRegisterCollectorPost(registerDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
  /**
   *
   * @param {EnableDisableCollectorDto} enableDisableCollectorDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authCollectorDisablePost(
    enableDisableCollectorDto: EnableDisableCollectorDto,
    options?: AxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .authCollectorDisablePost(enableDisableCollectorDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EnableDisableCollectorDto} enableDisableCollectorDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authCollectorEnablePost(
    enableDisableCollectorDto: EnableDisableCollectorDto,
    options?: AxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .authCollectorEnablePost(enableDisableCollectorDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ResetCollectorPassword} resetCollectorPassword
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authCollectorResetPwdPost(
    resetCollectorPassword: ResetCollectorPassword,
    options?: AxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .authCollectorResetPwdPost(resetCollectorPassword, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {LoginDto} loginDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authLoginPost(loginDto: LoginDto, options?: AxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .authLoginPost(loginDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authLogoutPost(options?: AxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .authLogoutPost(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ChangePasswordDto} changePasswordDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authPasswordChangePost(
    changePasswordDto: ChangePasswordDto,
    options?: AxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .authPasswordChangePost(changePasswordDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {RegisterDto} registerDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authRegisterAdminPost(
    registerDto: RegisterDto,
    options?: AxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .authRegisterAdminPost(registerDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {RegisterDto} registerDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authRegisterCollectorPost(
    registerDto: RegisterDto,
    options?: AxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .authRegisterCollectorPost(registerDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _options: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/*`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "OPTIONS",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {JsurlConverterPostRequest} jsurlConverterPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    jsurlConverterPost: async (
      jsurlConverterPostRequest: JsurlConverterPostRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'jsurlConverterPostRequest' is not null or undefined
      assertParamExists(
        "jsurlConverterPost",
        "jsurlConverterPostRequest",
        jsurlConverterPostRequest
      );
      const localVarPath = `/jsurl-converter`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        jsurlConverterPostRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async _options(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator._options(
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {JsurlConverterPostRequest} jsurlConverterPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async jsurlConverterPost(
      jsurlConverterPostRequest: JsurlConverterPostRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<JsurlConverterPostRequest>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.jsurlConverterPost(
          jsurlConverterPostRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DefaultApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _options(options?: any): AxiosPromise<void> {
      return localVarFp
        ._options(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {JsurlConverterPostRequest} jsurlConverterPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    jsurlConverterPost(
      jsurlConverterPostRequest: JsurlConverterPostRequest,
      options?: any
    ): AxiosPromise<JsurlConverterPostRequest> {
      return localVarFp
        .jsurlConverterPost(jsurlConverterPostRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public _options(options?: AxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      ._options(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {JsurlConverterPostRequest} jsurlConverterPostRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public jsurlConverterPost(
    jsurlConverterPostRequest: JsurlConverterPostRequest,
    options?: AxiosRequestConfig
  ) {
    return DefaultApiFp(this.configuration)
      .jsurlConverterPost(jsurlConverterPostRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * FilesApi - axios parameter creator
 * @export
 */
export const FilesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    filesGet: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/files/*`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<File>} files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    filesPost: async (
      files: Array<File>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'files' is not null or undefined
      assertParamExists("filesPost", "files", files);
      const localVarPath = `/files`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (files) {
        files.forEach((element) => {
          localVarFormParams.append("files", element as any);
        });
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FilesApi - functional programming interface
 * @export
 */
export const FilesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async filesGet(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.filesGet(
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {Array<File>} files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async filesPost(
      files: Array<File>,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<FileEntity>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.filesPost(
        files,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * FilesApi - factory interface
 * @export
 */
export const FilesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = FilesApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    filesGet(options?: any): AxiosPromise<void> {
      return localVarFp
        .filesGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<File>} files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    filesPost(
      files: Array<File>,
      options?: any
    ): AxiosPromise<Array<FileEntity>> {
      return localVarFp
        .filesPost(files, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * FilesApi - object-oriented interface
 * @export
 * @class FilesApi
 * @extends {BaseAPI}
 */
export class FilesApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FilesApi
   */
  public filesGet(options?: AxiosRequestConfig) {
    return FilesApiFp(this.configuration)
      .filesGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Array<File>} files
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FilesApi
   */
  public filesPost(files: Array<File>, options?: AxiosRequestConfig) {
    return FilesApiFp(this.configuration)
      .filesPost(files, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * FormResponsesApi - axios parameter creator
 * @export
 */
export const FormResponsesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} formId
     * @param {string} [submittedBy]
     * @param {ModelObject} [filter]
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdResponsesExportGet: async (
      formId: string,
      submittedBy?: string,
      filter?: ModelObject,
      skip?: number,
      limit?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'formId' is not null or undefined
      assertParamExists("formsFormIdResponsesExportGet", "formId", formId);
      const localVarPath = `/forms/{formId}/responses/export`.replace(
        `{${"formId"}}`,
        encodeURIComponent(String(formId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (submittedBy !== undefined) {
        localVarQueryParameter["submittedBy"] = submittedBy;
      }

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (skip !== undefined) {
        localVarQueryParameter["skip"] = skip;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} formId
     * @param {string} [submittedBy]
     * @param {ModelObject} [filter]
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdResponsesGet: async (
      formId: string,
      submittedBy?: string,
      filter?: ModelObject,
      skip?: number,
      limit?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'formId' is not null or undefined
      assertParamExists("formsFormIdResponsesGet", "formId", formId);
      const localVarPath = `/forms/{formId}/responses`.replace(
        `{${"formId"}}`,
        encodeURIComponent(String(formId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (submittedBy !== undefined) {
        localVarQueryParameter["submittedBy"] = submittedBy;
      }

      if (filter !== undefined) {
        localVarQueryParameter["filter"] = filter;
      }

      if (skip !== undefined) {
        localVarQueryParameter["skip"] = skip;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} formId
     * @param {ResponseDto} responseDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdResponsesPost: async (
      formId: string,
      responseDto: ResponseDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'formId' is not null or undefined
      assertParamExists("formsFormIdResponsesPost", "formId", formId);
      // verify required parameter 'responseDto' is not null or undefined
      assertParamExists("formsFormIdResponsesPost", "responseDto", responseDto);
      const localVarPath = `/forms/{formId}/responses`.replace(
        `{${"formId"}}`,
        encodeURIComponent(String(formId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        responseDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} responseId
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdResponsesResponseIdDelete: async (
      responseId: string,
      formId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'responseId' is not null or undefined
      assertParamExists(
        "formsFormIdResponsesResponseIdDelete",
        "responseId",
        responseId
      );
      // verify required parameter 'formId' is not null or undefined
      assertParamExists(
        "formsFormIdResponsesResponseIdDelete",
        "formId",
        formId
      );
      const localVarPath = `/forms/{formId}/responses/{responseId}`
        .replace(`{${"responseId"}}`, encodeURIComponent(String(responseId)))
        .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} responseId
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdResponsesResponseIdGet: async (
      responseId: string,
      formId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'responseId' is not null or undefined
      assertParamExists(
        "formsFormIdResponsesResponseIdGet",
        "responseId",
        responseId
      );
      // verify required parameter 'formId' is not null or undefined
      assertParamExists("formsFormIdResponsesResponseIdGet", "formId", formId);
      const localVarPath = `/forms/{formId}/responses/{responseId}`
        .replace(`{${"responseId"}}`, encodeURIComponent(String(responseId)))
        .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} responseId
     * @param {string} formId
     * @param {ResponseDto} responseDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdResponsesResponseIdPut: async (
      responseId: string,
      formId: string,
      responseDto: ResponseDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'responseId' is not null or undefined
      assertParamExists(
        "formsFormIdResponsesResponseIdPut",
        "responseId",
        responseId
      );
      // verify required parameter 'formId' is not null or undefined
      assertParamExists("formsFormIdResponsesResponseIdPut", "formId", formId);
      // verify required parameter 'responseDto' is not null or undefined
      assertParamExists(
        "formsFormIdResponsesResponseIdPut",
        "responseDto",
        responseDto
      );
      const localVarPath = `/forms/{formId}/responses/{responseId}`
        .replace(`{${"responseId"}}`, encodeURIComponent(String(responseId)))
        .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        responseDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FormResponsesApi - functional programming interface
 * @export
 */
export const FormResponsesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    FormResponsesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} formId
     * @param {string} [submittedBy]
     * @param {ModelObject} [filter]
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async formsFormIdResponsesExportGet(
      formId: string,
      submittedBy?: string,
      filter?: ModelObject,
      skip?: number,
      limit?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.formsFormIdResponsesExportGet(
          formId,
          submittedBy,
          filter,
          skip,
          limit,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} formId
     * @param {string} [submittedBy]
     * @param {ModelObject} [filter]
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async formsFormIdResponsesGet(
      formId: string,
      submittedBy?: string,
      filter?: ModelObject,
      skip?: number,
      limit?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<FormsFormIdResponsesGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.formsFormIdResponsesGet(
          formId,
          submittedBy,
          filter,
          skip,
          limit,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} formId
     * @param {ResponseDto} responseDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async formsFormIdResponsesPost(
      formId: string,
      responseDto: ResponseDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.formsFormIdResponsesPost(
          formId,
          responseDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} responseId
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async formsFormIdResponsesResponseIdDelete(
      responseId: string,
      formId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.formsFormIdResponsesResponseIdDelete(
          responseId,
          formId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} responseId
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async formsFormIdResponsesResponseIdGet(
      responseId: string,
      formId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.formsFormIdResponsesResponseIdGet(
          responseId,
          formId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} responseId
     * @param {string} formId
     * @param {ResponseDto} responseDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async formsFormIdResponsesResponseIdPut(
      responseId: string,
      formId: string,
      responseDto: ResponseDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.formsFormIdResponsesResponseIdPut(
          responseId,
          formId,
          responseDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * FormResponsesApi - factory interface
 * @export
 */
export const FormResponsesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = FormResponsesApiFp(configuration);
  return {
    /**
     *
     * @param {string} formId
     * @param {string} [submittedBy]
     * @param {ModelObject} [filter]
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdResponsesExportGet(
      formId: string,
      submittedBy?: string,
      filter?: ModelObject,
      skip?: number,
      limit?: number,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .formsFormIdResponsesExportGet(
          formId,
          submittedBy,
          filter,
          skip,
          limit,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} formId
     * @param {string} [submittedBy]
     * @param {ModelObject} [filter]
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdResponsesGet(
      formId: string,
      submittedBy?: string,
      filter?: ModelObject,
      skip?: number,
      limit?: number,
      options?: any
    ): AxiosPromise<FormsFormIdResponsesGet200Response> {
      return localVarFp
        .formsFormIdResponsesGet(
          formId,
          submittedBy,
          filter,
          skip,
          limit,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} formId
     * @param {ResponseDto} responseDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdResponsesPost(
      formId: string,
      responseDto: ResponseDto,
      options?: any
    ): AxiosPromise<ResponseEntity> {
      return localVarFp
        .formsFormIdResponsesPost(formId, responseDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} responseId
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdResponsesResponseIdDelete(
      responseId: string,
      formId: string,
      options?: any
    ): AxiosPromise<ResponseEntity> {
      return localVarFp
        .formsFormIdResponsesResponseIdDelete(responseId, formId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} responseId
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdResponsesResponseIdGet(
      responseId: string,
      formId: string,
      options?: any
    ): AxiosPromise<ResponseEntity> {
      return localVarFp
        .formsFormIdResponsesResponseIdGet(responseId, formId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} responseId
     * @param {string} formId
     * @param {ResponseDto} responseDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdResponsesResponseIdPut(
      responseId: string,
      formId: string,
      responseDto: ResponseDto,
      options?: any
    ): AxiosPromise<ResponseEntity> {
      return localVarFp
        .formsFormIdResponsesResponseIdPut(
          responseId,
          formId,
          responseDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * FormResponsesApi - object-oriented interface
 * @export
 * @class FormResponsesApi
 * @extends {BaseAPI}
 */
export class FormResponsesApi extends BaseAPI {
  /**
   *
   * @param {string} formId
   * @param {string} [submittedBy]
   * @param {ModelObject} [filter]
   * @param {number} [skip]
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormResponsesApi
   */
  public formsFormIdResponsesExportGet(
    formId: string,
    submittedBy?: string,
    filter?: ModelObject,
    skip?: number,
    limit?: number,
    options?: AxiosRequestConfig
  ) {
    return FormResponsesApiFp(this.configuration)
      .formsFormIdResponsesExportGet(
        formId,
        submittedBy,
        filter,
        skip,
        limit,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} formId
   * @param {string} [submittedBy]
   * @param {ModelObject} [filter]
   * @param {number} [skip]
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormResponsesApi
   */
  public formsFormIdResponsesGet(
    formId: string,
    submittedBy?: string,
    filter?: ModelObject,
    skip?: number,
    limit?: number,
    options?: AxiosRequestConfig
  ) {
    return FormResponsesApiFp(this.configuration)
      .formsFormIdResponsesGet(
        formId,
        submittedBy,
        filter,
        skip,
        limit,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} formId
   * @param {ResponseDto} responseDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormResponsesApi
   */
  public formsFormIdResponsesPost(
    formId: string,
    responseDto: ResponseDto,
    options?: AxiosRequestConfig
  ) {
    return FormResponsesApiFp(this.configuration)
      .formsFormIdResponsesPost(formId, responseDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} responseId
   * @param {string} formId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormResponsesApi
   */
  public formsFormIdResponsesResponseIdDelete(
    responseId: string,
    formId: string,
    options?: AxiosRequestConfig
  ) {
    return FormResponsesApiFp(this.configuration)
      .formsFormIdResponsesResponseIdDelete(responseId, formId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} responseId
   * @param {string} formId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormResponsesApi
   */
  public formsFormIdResponsesResponseIdGet(
    responseId: string,
    formId: string,
    options?: AxiosRequestConfig
  ) {
    return FormResponsesApiFp(this.configuration)
      .formsFormIdResponsesResponseIdGet(responseId, formId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} responseId
   * @param {string} formId
   * @param {ResponseDto} responseDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormResponsesApi
   */
  public formsFormIdResponsesResponseIdPut(
    responseId: string,
    formId: string,
    responseDto: ResponseDto,
    options?: AxiosRequestConfig
  ) {
    return FormResponsesApiFp(this.configuration)
      .formsFormIdResponsesResponseIdPut(
        responseId,
        formId,
        responseDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * FormsApi - axios parameter creator
 * @export
 */
export const FormsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdDelete: async (
      formId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'formId' is not null or undefined
      assertParamExists("formsFormIdDelete", "formId", formId);
      const localVarPath = `/forms/{formId}`.replace(
        `{${"formId"}}`,
        encodeURIComponent(String(formId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdGet: async (
      formId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'formId' is not null or undefined
      assertParamExists("formsFormIdGet", "formId", formId);
      const localVarPath = `/forms/{formId}`.replace(
        `{${"formId"}}`,
        encodeURIComponent(String(formId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} formId
     * @param {FormDto} formDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdPut: async (
      formId: string,
      formDto: FormDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'formId' is not null or undefined
      assertParamExists("formsFormIdPut", "formId", formId);
      // verify required parameter 'formDto' is not null or undefined
      assertParamExists("formsFormIdPut", "formDto", formDto);
      const localVarPath = `/forms/{formId}`.replace(
        `{${"formId"}}`,
        encodeURIComponent(String(formId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        formDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} formId
     * @param {UpdateFormStatusDto} updateFormStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdStatusPatch: async (
      formId: string,
      updateFormStatusDto: UpdateFormStatusDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'formId' is not null or undefined
      assertParamExists("formsFormIdStatusPatch", "formId", formId);
      // verify required parameter 'updateFormStatusDto' is not null or undefined
      assertParamExists(
        "formsFormIdStatusPatch",
        "updateFormStatusDto",
        updateFormStatusDto
      );
      const localVarPath = `/forms/{formId}/status`.replace(
        `{${"formId"}}`,
        encodeURIComponent(String(formId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateFormStatusDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {'DRAFT' | 'PUBLISHED' | 'ARCHIVED'} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsGet: async (
      status?: "DRAFT" | "PUBLISHED" | "ARCHIVED",
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/forms`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (status !== undefined) {
        localVarQueryParameter["status"] = status;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateFormDto} createFormDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsPost: async (
      createFormDto: CreateFormDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createFormDto' is not null or undefined
      assertParamExists("formsPost", "createFormDto", createFormDto);
      const localVarPath = `/forms`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createFormDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FormsApi - functional programming interface
 * @export
 */
export const FormsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FormsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async formsFormIdDelete(
      formId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.formsFormIdDelete(formId, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async formsFormIdGet(
      formId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormEntity>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.formsFormIdGet(
        formId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} formId
     * @param {FormDto} formDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async formsFormIdPut(
      formId: string,
      formDto: FormDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormEntity>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.formsFormIdPut(
        formId,
        formDto,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} formId
     * @param {UpdateFormStatusDto} updateFormStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async formsFormIdStatusPatch(
      formId: string,
      updateFormStatusDto: UpdateFormStatusDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.formsFormIdStatusPatch(
          formId,
          updateFormStatusDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {'DRAFT' | 'PUBLISHED' | 'ARCHIVED'} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async formsGet(
      status?: "DRAFT" | "PUBLISHED" | "ARCHIVED",
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<FormEntity>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.formsGet(
        status,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {CreateFormDto} createFormDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async formsPost(
      createFormDto: CreateFormDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormEntity>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.formsPost(
        createFormDto,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * FormsApi - factory interface
 * @export
 */
export const FormsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = FormsApiFp(configuration);
  return {
    /**
     *
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdDelete(formId: string, options?: any): AxiosPromise<FormEntity> {
      return localVarFp
        .formsFormIdDelete(formId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdGet(formId: string, options?: any): AxiosPromise<FormEntity> {
      return localVarFp
        .formsFormIdGet(formId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} formId
     * @param {FormDto} formDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdPut(
      formId: string,
      formDto: FormDto,
      options?: any
    ): AxiosPromise<FormEntity> {
      return localVarFp
        .formsFormIdPut(formId, formDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} formId
     * @param {UpdateFormStatusDto} updateFormStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsFormIdStatusPatch(
      formId: string,
      updateFormStatusDto: UpdateFormStatusDto,
      options?: any
    ): AxiosPromise<FormEntity> {
      return localVarFp
        .formsFormIdStatusPatch(formId, updateFormStatusDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {'DRAFT' | 'PUBLISHED' | 'ARCHIVED'} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsGet(
      status?: "DRAFT" | "PUBLISHED" | "ARCHIVED",
      options?: any
    ): AxiosPromise<Array<FormEntity>> {
      return localVarFp
        .formsGet(status, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateFormDto} createFormDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    formsPost(
      createFormDto: CreateFormDto,
      options?: any
    ): AxiosPromise<FormEntity> {
      return localVarFp
        .formsPost(createFormDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * FormsApi - object-oriented interface
 * @export
 * @class FormsApi
 * @extends {BaseAPI}
 */
export class FormsApi extends BaseAPI {
  /**
   *
   * @param {string} formId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormsApi
   */
  public formsFormIdDelete(formId: string, options?: AxiosRequestConfig) {
    return FormsApiFp(this.configuration)
      .formsFormIdDelete(formId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} formId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormsApi
   */
  public formsFormIdGet(formId: string, options?: AxiosRequestConfig) {
    return FormsApiFp(this.configuration)
      .formsFormIdGet(formId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} formId
   * @param {FormDto} formDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormsApi
   */
  public formsFormIdPut(
    formId: string,
    formDto: FormDto,
    options?: AxiosRequestConfig
  ) {
    return FormsApiFp(this.configuration)
      .formsFormIdPut(formId, formDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} formId
   * @param {UpdateFormStatusDto} updateFormStatusDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormsApi
   */
  public formsFormIdStatusPatch(
    formId: string,
    updateFormStatusDto: UpdateFormStatusDto,
    options?: AxiosRequestConfig
  ) {
    return FormsApiFp(this.configuration)
      .formsFormIdStatusPatch(formId, updateFormStatusDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {'DRAFT' | 'PUBLISHED' | 'ARCHIVED'} [status]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormsApi
   */
  public formsGet(
    status?: "DRAFT" | "PUBLISHED" | "ARCHIVED",
    options?: AxiosRequestConfig
  ) {
    return FormsApiFp(this.configuration)
      .formsGet(status, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateFormDto} createFormDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormsApi
   */
  public formsPost(createFormDto: CreateFormDto, options?: AxiosRequestConfig) {
    return FormsApiFp(this.configuration)
      .formsPost(createFormDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {'ADMIN' | 'COLLECTOR'} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersGet: async (
      role?: "ADMIN" | "COLLECTOR",
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (role !== undefined) {
        localVarQueryParameter["role"] = role;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMeGet: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/users/me`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdDelete: async (
      userId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("usersUserIdDelete", "userId", userId);
      const localVarPath = `/users/{userId}`.replace(
        `{${"userId"}}`,
        encodeURIComponent(String(userId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdGet: async (
      userId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("usersUserIdGet", "userId", userId);
      const localVarPath = `/users/{userId}`.replace(
        `{${"userId"}}`,
        encodeURIComponent(String(userId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} userId
     * @param {UpdateUserDto} updateUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdPut: async (
      userId: string,
      updateUserDto: UpdateUserDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("usersUserIdPut", "userId", userId);
      // verify required parameter 'updateUserDto' is not null or undefined
      assertParamExists("usersUserIdPut", "updateUserDto", updateUserDto);
      const localVarPath = `/users/{userId}`.replace(
        `{${"userId"}}`,
        encodeURIComponent(String(userId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication cookie required

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateUserDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {'ADMIN' | 'COLLECTOR'} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersGet(
      role?: "ADMIN" | "COLLECTOR",
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<UserEntity>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersGet(
        role,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersMeGet(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersMeGet(
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersUserIdDelete(
      userId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.usersUserIdDelete(userId, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersUserIdGet(
      userId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserIdGet(
        userId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} userId
     * @param {UpdateUserDto} updateUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersUserIdPut(
      userId: string,
      updateUserDto: UpdateUserDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserIdPut(
        userId,
        updateUserDto,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UsersApiFp(configuration);
  return {
    /**
     *
     * @param {'ADMIN' | 'COLLECTOR'} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersGet(
      role?: "ADMIN" | "COLLECTOR",
      options?: any
    ): AxiosPromise<Array<UserEntity>> {
      return localVarFp
        .usersGet(role, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMeGet(options?: any): AxiosPromise<UserEntity> {
      return localVarFp
        .usersMeGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdDelete(userId: string, options?: any): AxiosPromise<UserEntity> {
      return localVarFp
        .usersUserIdDelete(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdGet(userId: string, options?: any): AxiosPromise<UserEntity> {
      return localVarFp
        .usersUserIdGet(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} userId
     * @param {UpdateUserDto} updateUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdPut(
      userId: string,
      updateUserDto: UpdateUserDto,
      options?: any
    ): AxiosPromise<UserEntity> {
      return localVarFp
        .usersUserIdPut(userId, updateUserDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
  /**
   *
   * @param {'ADMIN' | 'COLLECTOR'} [role]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public usersGet(role?: "ADMIN" | "COLLECTOR", options?: AxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .usersGet(role, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public usersMeGet(options?: AxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .usersMeGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public usersUserIdDelete(userId: string, options?: AxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .usersUserIdDelete(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public usersUserIdGet(userId: string, options?: AxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .usersUserIdGet(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} userId
   * @param {UpdateUserDto} updateUserDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public usersUserIdPut(
    userId: string,
    updateUserDto: UpdateUserDto,
    options?: AxiosRequestConfig
  ) {
    return UsersApiFp(this.configuration)
      .usersUserIdPut(userId, updateUserDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
